export default __webpack_public_path__ + "static/media/6.1692625c.png";